import { MAX_WIDTH_TABLET } from "../constants/dimension";
import { PageRoutes } from "../constants/routes";
import { isHashRouting } from "../utils/platform";

export const getDemoDomainClusterId = () => {
  const hostname = window.location.hostname;
  // Pattern: <xxx>.demo.virtualconsole.gg
  // Pattern: <xxx>.gambon.onmogaming.com
  const match = hostname.match(
    /^([^.]+)\.(demo\.virtualconsole\.gg|gambon\.onmogaming\.com)$/,
  );
  if (match) {
    return match[1];
  }
  return undefined;
};

const parseRouteFragment = (): { pathname: string; search: string } => {
  let rest = window.location.hash.slice(1);

  const anchorStart = rest.indexOf("#");
  if (anchorStart !== -1) rest = rest.slice(0, anchorStart);

  const queryStart = rest.indexOf("?");
  const search = queryStart === -1 ? "" : rest.slice(queryStart);
  let pathname = queryStart === -1 ? rest : rest.slice(0, queryStart);

  if (!pathname) pathname = "/";
  else if (!pathname.startsWith("/") && !pathname.startsWith("."))
    pathname = `/${pathname}`;

  return { pathname, search };
};

export const getRoutePath = (): string => {
  if (!isHashRouting) return window.location.pathname;
  // "" until react-router writes the first "#/", then "#/game/123?x=1".
  return parseRouteFragment().pathname;
};

export const getRouteSearch = (): string => {
  if (!isHashRouting) return window.location.search;
  return parseRouteFragment().search;
};

/**
 * The `data-gamepad` id of the nav-menu item for the current route.
 * Callers needing a selector: `[data-gamepad="${getMenuGamepadId()}"]`.
 */
export const getMenuGamepadId = (): string => `menu-${getRoutePath()}`;

export const isMobileSettingsPage = () => {
  return (
    getRoutePath() === PageRoutes.Settings &&
    window.innerWidth < MAX_WIDTH_TABLET
  );
};

export const isGamePlay = (location = getRoutePath()) => {
  return location.startsWith(PageRoutes.GamePlay);
};
